import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  responseContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  sectionTitle: {
    fontWeight: 600,
    color: theme.palette.text.primary,
  },
  dateText: {
    color: theme.palette.white,
  },
  adhesionSection: {
    display: 'flex',
    flexDirection: 'column',
  },
  adhesionContent: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
  },
  adhesionChip: {
    fontWeight: 700,
    fontSize: '1.2rem',
    width: 40,
    height: 40,
    borderRadius: '50%',
  },
  adhesionLevel: {
    fontWeight: 500,
    color: theme.palette.text.secondary,
  },
  divider: {
    margin: theme.spacing(1, 0),
  },
  justificationText: {
    color: theme.palette.text.secondary,
    lineHeight: 1.6,
    textAlign: 'justify',
    whiteSpace: 'pre-line',
  },
  guidelinesHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  guidelinesIcon: {
    color: theme.palette.warning.main,
  },
  guidelinesList: {
    padding: 0,
  },
  guidelineItem: {
    alignItems: 'flex-start',
    paddingInline: 0,
  },
  guidelineNumber: {
    minWidth: 36,
    marginTop: theme.spacing(1),
  },
  guidelineIcon: {
    display: 'flex',
    alignContent: 'center',
    alignItems: 'center',
    padding: 2,
    borderRadius: '50%',
    backgroundColor: theme.palette.primary.main,
  },
  containerNumberText: {
    width: 24,
    height: 24,
    justifyContent: 'center',
  },
  numberText: {
    color: theme.palette.primary.contrastText,
    fontWeight: 600,
    fontSize: '0.75rem',
  },
  guidelineText: {
    color: theme.palette.text.secondary,
    lineHeight: 1.5,
  },
}))

export default styles
